import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import React from 'react';

export const PaginatedTable = ({
  headers,
  rowValues,
  handleRowClick,
  currentPage,
  totalCount,
  handlePageChange,
}: {
  headers: { columnName: string; display: string }[];
  rowValues: any[];
  handleRowClick: (row: any) => void;
  currentPage: number;
  totalCount: number;
  handlePageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
}) => {
  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {headers.map((header: any) => (
                  <TableCell
                    key={header.columnName}
                    sx={{
                      color: 'rgba(0,0,0,0.55)',
                    }}
                  >
                    {header.display}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowValues.map((row, idx) => {
                return (
                  <TableRow
                    onClick={() => handleRowClick(row)}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={idx}
                    sx={{
                      '&:hover': {
                        cursor: 'pointer',
                      },
                    }}
                  >
                    {headers.map((header: any) => {
                      const value = row[header.columnName];
                      return (
                        <TableCell key={header.columnName} align={'left'}>
                          {value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={totalCount}
          rowsPerPage={10}
          page={currentPage}
          onPageChange={handlePageChange}
        />
      </Paper>
    </>
  );
};
